import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import ApiContext from '../../utils/api-context'
import { gql, useQuery } from '@apollo/client'
import Wrapper from '../layout/grid/wrapper'
import { Container, Grid } from '@material-ui/core'
import ProgressiveImage from 'react-progressive-image-loading'
import ArticleStyles from './article-styles'
import ReactMarkdown from 'react-markdown'
import globalStyles from '../../styles/global-styles.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faFacebook,
  faTwitter,
  faInstagram,
} from '@fortawesome/free-brands-svg-icons'
import Author from '../author'
import Carousel from 'nuka-carousel'
import { carouselNext, carouselPrev, renderDots } from '../carousels'
import Chevron from '../svg/Chevron.svg'
import ChevronCircle from '../svg/ChevronCircle.svg'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import Link from 'next/link'
import Share from '../share'
import { ReactComponent } from '*.svg'
import Image from 'next/image'
import EmbedVideo from '../embed-video'

const ARTICLE = gql`
  query getBlogArticles($locale: String, $where: JSON) {
    blogArticles(locale: $locale, where: $where) {
      published_at
      created_at
      updated_at
      title
      slug
      standfirst
      content {
        ... on ComponentBlogBlogTextBlock {
          heading
          content
        }
        ... on ComponentBlogGallery {
          images {
            url
            alternativeText
          }
        }
        ... on ComponentBlogSingleImage {
          image {
            url
            alternativeText
          }
        }
        ... on ComponentBlogDoubleImage {
          image1 {
            url
            alternativeText
          }
          image2 {
            url
            alternativeText
          }
        }
        ... on ComponentBlogAdvert {
          url
          advertImage {
            url
            alternativeText
          }
        }
        ... on ComponentBlogQuote {
          content
        }
      }
      featuredImage {
        alternativeText
        ext
        url
      }
      categories {
        slug
        name
      }
      author {
        id
        username
        email
        firstname
        lastname
        profileImage {
          alternativeText
          ext
          url
        }
      }
      tags {
        name
      }
    }
  }
`

const Article = (props) => {
  const { article } = props
  const { i18n } = useTranslation()
  const router = useRouter()
  const moment = require('moment')
  const { apiUrl, cdnUrl } = useContext(ApiContext)

  const classes = ArticleStyles({})
  // const where = {}
  // where[`slug`] = props.articleSlug
  // const { loading, error, data } = useQuery(ARTICLE, {
  //   variables: {
  //     where,
  //     locale: i18n.language,
  //   },
  // })
  //
  // if (loading) return <p>LOADING</p>
  // if (
  //   error ||
  //   !data.hasOwnProperty('blogArticles') ||
  //   data.blogArticles.length !== 1
  // )
  //   return <p>ERROR</p>

  const localRender = (props) => {
    return renderDots({
      ...props,
      dotClass: classes.dots,
      activeClass: classes.activeDot,
    })
  }

  const controlContainerStyles = (key) => {
    let position = {}
    switch (key) {
      case 'CenterLeft':
        position = {
          left: '1rem',
          // width: 48,
        }
        break
      case 'CenterRight':
        position = {
          left: 'auto',
          right: '1rem',
          // width: 48,
        }
        break
      case 'BottomCenter':
        position = {
          bottom: '1rem',
        }
        break
    }
    return position
  }

  const localNext = ({
    nextSlide,
    currentSlide,
    slideCount,
    slidesToScroll,
  }) => {
    const buttonProps = {
      onClick: props.nextSlide,
      'aria-label': 'next',
      disabled: false,
      className: classes.carouselButton,
    }
    if (props.currentSlide === props.slideCount - props.slidesToScroll) {
      buttonProps.disabled = true
      buttonProps['aria-disabled'] = true
    }
    return (
      <button {...buttonProps}>
        <Chevron />
      </button>
    )
  }

  const localPrev = ({ previousSlide, currentSlide }) => {
    const buttonProps = {
      onClick: props.previousSlide,
      'aria-label': 'previous',
      disabled: false,
      className: classes.carouselButton,
      style: { transform: 'rotate(-180deg)' },
    }
    if (props.currentSlide === 0) {
      buttonProps.disabled = true
      buttonProps['aria-disabled'] = true
    }
    return (
      <button {...buttonProps}>
        <Chevron />
      </button>
    )
  }

  // const article = data
  // console.log(article.featuredImage)

  return (
    <div className={classes.wrapper}>
      <Container maxWidth={'lg'}>
        <Grid container spacing={3} justify={'center'}>
          <Grid item xs={12} md={7}>
            <div className={classes.heading}>
              <h1>{article[`title`]}</h1>
              <hr />
              <div className={globalStyles.categoryTags}>
                {article.tags.map((tag, i) => {
                  return (
                    <React.Fragment key={i}>
                      <span>{tag[`name`]}</span>{' '}
                    </React.Fragment>
                  )
                })}
              </div>
            </div>
          </Grid>
          {article.featuredImage && article.featuredImage.formats && (
            <Grid item xs={12} lg={11}>
              <div className={classes.image}>
                {article.featuredImage.formats &&
                  article.featuredImage.formats.large && (
                    <Image
                      src={article.featuredImage.formats.large.url}
                      alt={article.featuredImage.alternativeText}
                      placeholder={'blur'}
                      blurDataURL={article.featuredImage.formats.thumbnail.url}
                      layout={'responsive'}
                      width={988}
                      height={556}
                    />
                  )}
                {(!article.featuredImage.formats ||
                  !article.featuredImage.formats.large) && (
                  <Image
                    src={article.featuredImage.url}
                    alt={article.featuredImage.alternativeText}
                    layout={'responsive'}
                    width={988}
                    height={556}
                  />
                )}
              </div>
            </Grid>
          )}

          <Grid item sm={12} lg={10}>
            <div className={classes.articleWrapper}>
              <div className={classes.sharing}>
                <h5>Sharing:</h5>
                <Share
                  title={article.title}
                  url={router.asPath}
                  size={'small'}
                  hideHeading={true}
                />
              </div>
              <div className={classes.articleContent}>
                <div className={classes.standfirst}>
                  {article[`standfirst`] !== null && (
                    <p className={globalStyles.dropCap}>
                      {article[`standfirst`]}
                    </p>
                  )}
                </div>
                <div className={classes.bodyContent}>
                  {article.content &&
                    article.content.map((item: any, i: number) => {
                      return (
                        <React.Fragment key={i}>
                          {item.__component === 'general.video-block' && (
                            <div className={classes.bodyContentVideo}>
                              {item.friendlyName &&
                                item.friendlyName !== '' && (
                                  <h2>{item.friendlyName}</h2>
                                )}
                              <div className="video-wrapper">
                                {item.uploadedVideo && (
                                  <video
                                    controls
                                    poster={
                                      item.poster
                                        ? item.poster.formats.medium.url
                                        : ''
                                    }
                                  >
                                    <source
                                      src={item.uploadedVideo.url}
                                      type={item.uploadedVideo.mime}
                                    />
                                  </video>
                                )}
                                {item.remoteVideo && (
                                  <EmbedVideo url={item.remoteVideo} />
                                )}
                              </div>
                            </div>
                          )}
                          {item.__component === 'blog.blog-text-block' && (
                            <div className={classes.bodyContentText}>
                              {item.heading && item.heading !== '' && (
                                <h2>{item.heading}</h2>
                              )}
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: item.content,
                                }}
                              />
                            </div>
                          )}
                          {item.__component === 'blog.double-image' && (
                            <div className={classes.articleImages}>
                              <img src={`${item.image1.url}`} alt={''} />
                              <img src={`${item.image2.url}`} alt={''} />
                            </div>
                          )}
                          {item.__component === 'blog.single-image' && (
                            <div>
                              <img src={`${item.image.url}`} alt={''} />
                            </div>
                          )}
                          {item.__component === 'blog.heading' && (
                            <div className={classes.bodyContentText}>
                              <h2>{item.content}</h2>
                            </div>
                          )}
                          {item.__component === 'blog.sub-heading' && (
                            <div className={classes.bodyContentText}>
                              <h3>{item.content}</h3>
                            </div>
                          )}
                          {item.__component === 'blog.paragraph' && (
                            <div
                              dangerouslySetInnerHTML={{ __html: item.content }}
                              className={classes.bodyContentText}
                            />
                          )}
                          {item.__component === 'blog.quote' && (
                            <blockquote>
                              <p>{item.content}</p>
                            </blockquote>
                          )}
                          {item.__component === 'blog.advert' && (
                            <div className={classes.advert}>
                              <Link href={item.url}>
                                <a>
                                  <img src={`${item.advertImage.url}`} alt="" />
                                </a>
                              </Link>
                            </div>
                          )}
                          {item.__component === 'blog.gallery' && (
                            <div className={classes.carsouselWrapper}>
                              <Carousel
                                renderCenterLeftControls={localPrev}
                                renderCenterRightControls={localNext}
                                // getControlsContainerStyles={
                                //   controlContainerStyles
                                // }
                                renderBottomCenterControls={localRender}
                              >
                                {item.images &&
                                  item.images.length > 0 &&
                                  item.images.map((image, j) => {
                                    return (
                                      <img
                                        src={`${image.url}`}
                                        alt=""
                                        key={j}
                                      />
                                    )
                                  })}
                              </Carousel>
                            </div>
                          )}
                        </React.Fragment>
                      )
                    })}
                </div>
                {article.author && <Author author={article.author} />}
              </div>
              <p className={classes.createdAt}>
                {moment(article.updated_at).format('DD MMM YYYY')}
              </p>
            </div>
          </Grid>
        </Grid>
      </Container>
    </div>
  )
}
Article.propTypes = {
  categorySlug: PropTypes.string.isRequired,
  articleSlug: PropTypes.string.isRequired,
  article: PropTypes.object.isRequired,
}
export default Article
